import { render, staticRenderFns } from "./Banner-sdc-desktop.vue?vue&type=template&id=23cae0ac&scoped=true"
import script from "./Banner-sdc-desktop.vue?vue&type=script&lang=js"
export * from "./Banner-sdc-desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cae0ac",
  null
  
)

export default component.exports